"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonBack = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var router_1 = require("next/router");
var styled_components_1 = __importDefault(require("styled-components"));
var styles_1 = require("../../styles");
var hooks_1 = require("../../hooks");
var Button = styled_components_1.default.button(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  align-items: center;\n  background-color: #262626;\n  border-radius: ", ";\n  display: flex;\n  height: ", ";\n  justify-content: center;\n  left: ", ";\n  position: fixed;\n  top: 82px;\n  transition: 200ms all ", ";\n  width: ", ";\n  z-index: 20;\n\n  ", "\n\n  img {\n    transform: rotate(90deg);\n    width: ", ";\n\n    ", "\n  }\n"], ["\n  align-items: center;\n  background-color: #262626;\n  border-radius: ", ";\n  display: flex;\n  height: ", ";\n  justify-content: center;\n  left: ", ";\n  position: fixed;\n  top: 82px;\n  transition: 200ms all ", ";\n  width: ", ";\n  z-index: 20;\n\n  ", "\n\n  img {\n    transform: rotate(90deg);\n    width: ", ";\n\n    ", "\n  }\n"])), function (_a) {
    var sticky = _a.sticky;
    return sticky ? 0 : '50%';
}, (0, styles_1.getRelative)(50, 'mobile'), (0, styles_1.getRelative)(20, 'mobile'), function (_a) {
    var theme = _a.theme;
    return theme.ease;
}, (0, styles_1.getRelative)(50, 'mobile'), styles_1.mq.greaterThan('tablet')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: ", ";\n    left: ", ";\n    top: ", ";\n    width: ", ";\n  "], ["\n    height: ", ";\n    left: ", ";\n    top: ", ";\n    width: ", ";\n  "])), (0, styles_1.getRelative)(80, 'desktop'), function (_a) {
    var sticky = _a.sticky;
    return sticky ? 0 : "".concat((0, styles_1.getRelative)(20, 'desktop'));
}, function (_a) {
    var sticky = _a.sticky, scrollTop = _a.scrollTop;
    return sticky ? '80px' : "".concat(scrollTop ? '120px' : '92px');
}, function (_a) {
    var sticky = _a.sticky;
    return (0, styles_1.getRelative)(sticky ? 120 : 80, 'desktop');
}), (0, styles_1.getRelative)(8, 'mobile'), styles_1.mq.greaterThan('tablet')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      width: ", ";\n    "], ["\n      width: ", ";\n    "])), (0, styles_1.getRelative)(18, 'desktop')));
exports.ButtonBack = (0, react_1.memo)(function (_a) {
    var _b = _a.sticky, sticky = _b === void 0 ? false : _b;
    var scrollState = (0, hooks_1.useScrollViewer)(80);
    var scrollTop = (0, react_1.useMemo)(function () { return scrollState === 'TOP'; }, [scrollState]);
    var router = (0, router_1.useRouter)() || { back: function () { } };
    var onClick = function () {
        router.back();
    };
    return ((0, jsx_runtime_1.jsx)(Button, __assign({ sticky: sticky, scrollTop: scrollTop, onClick: onClick, title: 'Ir atr\u00E1s' }, { children: (0, jsx_runtime_1.jsx)("img", { src: '/images/svg/i--chevron--white.svg', alt: 'Icon arrow back', width: '16', height: '16' }) })));
});
var templateObject_1, templateObject_2, templateObject_3;
